import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Footer from '../../Components/Footer/Footer';
import Header from '../../Components/Header/Header';
import ProfileTab from '../../Components/Profile/ProfileTabs';
import profile_img from '../../assets/images/profile_img.png'
import { UpdatePasswordApi, UpdateProfile } from '../../Redux/Auth/Auth_Action';

const EditProfile = () => {

    const reduxState = useSelector((state) => state.Auth.user);
    const reduxStateToken = useSelector((state) => state.Auth.token);

    const dispatch = useDispatch();
    let navigate = useNavigate();
    let pathname = window.location.pathname;

    // console.log('from reduxState editprofile', reduxStateToken);

    const [updateProfile, setUpdateProfile] = useState({
        f_name: reduxState.first_name || null,
        l_name: reduxState.last_name || null,
        phone_no: reduxState.phone_no || null,
    });

    const [selectedImage, setSelectedImage] = useState(reduxState.profile_picture || profile_img);
    const [updateImage, setUpdateImage] = useState(null);
    const [passState, setPassState] = useState({
        password: "",
        npassword: "",
        cnpassword: "",
    })

    const InputVal = (e) => {
        let { name, value } = e.target;
        setUpdateProfile({ ...updateProfile, [name]: value });
    }

    useEffect(() => {
        setUpdateImage(selectedImage);
        // console.log("updateImage", updateImage);
        // console.log("selectedImage", selectedImage);

    }, [])

    const UploadImage = (event) => {
        if ((event.target.files[0].size / 1000000) <= 5) {
            setUpdateImage(event.target.files[0])
            setSelectedImage(URL.createObjectURL(event.target.files[0]));
            // props.updateImage({ ...updateProfile, prof_img: event.target.files[0] })
            // console.log('sucess', (event.target.files[0].size / 1000000));
            // console.log(selectedImage,'selectedImageselectedImage')
        } else {
            toast.error("file size is greater than 5 mb");
        }
    }


    const Logout = () => {
        dispatch({ type: "DEL_TOKEN" })
        navigate("/");
    }

    const InputPassword = (e) => {
        let { name, value } = e.target;
        setPassState({ ...passState, [name]: value });
    }

    const SubmitProfileData = (e) => {
        // let profile = {
        //     first_name: ((updateProfile.f_name == null ? reduxState.first_name : updateProfile.f_name)),
        //     last_name: ((updateProfile.l_name == null ? reduxState.last_name : updateProfile.l_name)),
        //     avatar: ((selectedImage == null ? reduxState.profile_picture : selectedImage)),
        //     phone_no: ((updateProfile.phone_no == null ? reduxState.last_name : updateProfile.phone_no)),
        // }

        let profile = new FormData();    //formdata object

        profile.append('first_name', updateProfile.f_name);   //append the values with key, value pair
        profile.append('last_name', updateProfile.l_name);
        profile.append('avatar', updateImage);
        profile.append('phone_no', updateProfile.phone_no);
        e.preventDefault();

        dispatch(UpdateProfile(profile, reduxStateToken))
            .then((res) => {
                toast.success("Profile Update Successfully");
                // window.location.reload(true);
            }).catch((e) => {
                console.log('error from update profile ', e);
                toast.error("Profile Update Unsuccessfully");
            });
    }

    const SubmitNewPassword = (e) => {
        if (!passState.password || !passState.npassword || !passState.cnpassword) {
            toast.error("fill all password fields");
        } else if (passState.npassword != passState.cnpassword) {
            toast.error("new password and confirm new password does not match");
        } else if (passState.npassword.length < 8) {
            toast.error("password must contain 8 characters");
        } else {
            e.preventDefault();
            let UpdatePass = {
                current_password: passState.password,
                password: passState.npassword,
                confirm_password: passState.cnpassword,
            }
            dispatch(UpdatePasswordApi(UpdatePass, reduxStateToken))
                .then((res) => {
                    toast.success('Password Change Successfully. Please Login Again');
                    // console.log("res from update password api", res);
                    Logout();
                }).catch((e) => {
                    // toast.error("Network error")
                    // console.log(e, 'error from update Password Api');
                })
        }
    }

    // console.log(selectedImage, 'from profile page')

    return (
        <div>
            <section className='profile edit_profile'>
                <Header />
                <div className='container px-4'>
                    <div className='row'>
                        <div className='col-lg-12 text-center'>
                            <p className='f-pop-bold f-43 mb-5 mt-3'>My Profile</p>
                        </div>
                        <div className='col-lg-4'>
                            {/* <ProfileTab  /> */}
                            <div className='profile'>
                                <div className='pink_div'>
                                    <div style={{ backgroundImage: `url(${(selectedImage)})` }} className='bg-prof-img pos-rel'>
                                        <div className='change_profile f-mon-reg'>
                                            <label htmlFor="fileUpload">
                                                <div>
                                                    <p className='hvr_p'>Change Image</p>
                                                </div>
                                            </label>
                                            <input onChange={UploadImage} hidden id="fileUpload" type="file" accept="image/*" />
                                        </div>
                                    </div>

                                    <p className='f-mon-bold f-25 mt-2 mb-4'>
                                        {`${reduxState.first_name} ${reduxState?.last_name}`}
                                    </p>
                                    <p onClick={() => { navigate('/profile') }}
                                        // f-mon-semibold f-20 clr-white-light my-3 cursor_pointer maaaaaaz
                                        className={`${(pathname === "/editprofile" || pathname === "/profile") ? "f-mon-semibold f-20 clr-white-light my-3 cursor_pointer activ_link_prof" : " f-mon-semibold f-20 clr-white-light my-3 cursor_pointer"}`}>Account</p>
                                    <div className='border-bottom-white-light'></div>
                                    <p onClick={() => { navigate('/subscription') }}
                                        className={`${(pathname === "/subscription") ? "f-mon-semibold f-20 clr-white-light my-3 cursor_pointer activ_link_prof" : " f-mon-semibold f-20 clr-white-light my-3 cursor_pointer"}`}>My Subscription</p>
                                    <div className='border-bottom-white-light'></div>
                                    {/* <p onClick={() => { navigate('/packages') }}
                                        className={`${(pathname === "/payment") ? "f-mon-semibold f-20 clr-white-light my-3 cursor_pointer activ_link_prof" : " f-mon-semibold f-20 clr-white-light my-3 cursor_pointer"}`}>Packages</p>
                                    <div className='border-bottom-white-light'></div> */}
                                    <p onClick={Logout}
                                        className={`${(pathname === "/") ? "f-mon-semibold f-20 clr-white-light my-3 cursor_pointer activ_link_prof" : " f-mon-semibold f-20 clr-white-light my-3 cursor_pointer"}`}>Logout</p>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-8 px-5 mb-5 edt-prf-res-p-m'>
                            <div className='row'>
                                <div className='col-lg-12'>
                                    <p className='f-pop-bold f-30'>Account</p>
                                </div>

                                <div className='col-lg-6'>
                                    <p className='mb-3 f-15 f-pop-med'>First Name</p>
                                    <input
                                        onChange={InputVal} value={updateProfile.f_name || ""}
                                        name="f_name"
                                        type="text" placeholder={`${reduxState.first_name}`} className='form-control p-4 rounded-0 f-15 f-pop-med' />
                                    <p className='my-3 f-15 f-pop-med'>Phone Number</p>
                                    <input
                                        onChange={InputVal} value={updateProfile.phone_no || ""}
                                        name="phone_no"
                                        type="text" placeholder={`${reduxState.phone_no}`} className='form-control p-4 rounded-0 f-15 f-pop-med' />
                                </div>

                                <div className='col-lg-6'>
                                    <p className='mb-3 f-15 f-pop-med'>Last Name</p>
                                    <input
                                        onChange={InputVal} value={updateProfile.l_name || ""}
                                        name="l_name" type="text" placeholder={`${reduxState.last_name}`} className='form-control p-4 rounded-0 f-15 f-pop-med' />
                                    <p className='my-3 f-15 f-pop-med'>Email</p>
                                    <input
                                        type="text" disabled placeholder={`${reduxState.email}`} className='form-control p-4 rounded-0 f-15 f-pop-med' />
                                </div>

                                <div className='col-lg-12'>
                                    <button onClick={SubmitProfileData} className='btn btn-light bt-profile-grn f-mon-reg f-16 mt-4'>SAVE CHANGES</button>
                                </div>

                                <div className='col-lg-6 mt-4'>
                                    <p className='my-3 f-15 f-pop-med'>Current Password</p>
                                    <input
                                        onChange={InputPassword} value={passState.password || ""}
                                        name="password"
                                        type="password" placeholder='*******' className='form-control p-4 rounded-0 f-15 f-pop-med' />
                                </div>

                                <div className='col-lg-6'>

                                </div>

                                <div className='col-lg-6 mt-1'>
                                    <p className='my-3 f-15 f-pop-med'>New Password</p>
                                    <input
                                        onChange={InputPassword} value={passState.npassword || ""}
                                        name="npassword"
                                        type="password" placeholder='Enter New Password' className='form-control p-4 rounded-0 f-15 f-pop-med' />
                                </div>

                                <div className='col-lg-6 mt-1'>
                                    <p className='my-3 f-15 f-pop-med'>Confirm New Password</p>
                                    <input
                                        onChange={InputPassword} value={passState.cnpassword || ""}
                                        name="cnpassword"
                                        type="password" placeholder='Enter New Password' className='form-control p-4 rounded-0 f-15 f-pop-med' />
                                </div>

                                <div className='col-lg-12'>
                                    <button onClick={SubmitNewPassword} className='btn btn-light bt-profile-grn f-mon-reg f-16 mt-4'>UPDATE PASSWORD</button>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    )
}

export default EditProfile;